import { PortalProducts } from '~/analytics/types/analytics.type'

import AnalyticsEvents_V2 from '../analyticsGA4'

class PlaycanvasAnalyticsEventLogger extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.PLAYCANVAS)
  }

  public logPlayCanvasEvent({ type, data }: MessageEvent): void {
    if (type !== 'playcanvasAnalyticsEvent') return

    if (data.meta) {
      const { meta, event, eventAction, eventCategory, eventValue, eventLabel, ...rest } = data
      this.logEvent({ event: event || eventAction, product: eventCategory, ...rest, ...meta })
      return
    }
    this.logEvent(data)
  }
}

export default new PlaycanvasAnalyticsEventLogger()

/*
need to discuss with erling

/bootcamp/numbers-and-quantities/multiplication/4/7/quiz
{
    "d": 11,
    "type": "message",
    "data": {
        "state": "ready"
    }
}

/games/multgame
{
    "d": 12,
    "type": "playcanvasAnalyticsEvent",
    "data": {
        "sessionId": "17da90f2-4a8d-4bc0-ae61-4736d9664339",
        "eventCategory": "multiplicationGame",
        "eventAction": "statbuttonpressed",
        "eventLabel": "",
        "eventValue": 10,
        "meta": {
            "time": 1678184643136
        }
    }
}

/games/stacknload
{
    "d": 13,
    "type": "playcanvasAnalyticsEvent",
    "data": {
        "sessionId": "f1042456-8736-415c-961e-f0c1c235edb9",
        "eventCategory": "stacknload",
        "eventAction": "levelStart",
        "eventLabel": "",
        "eventValue": 30,
        "meta": {
            "levelName": "tutorial-1"
        }
    }
}


/dashboard
{
    "d": 14,
    "type": "request",
    "data": undefined,
}

/dashboard
{
    "d": 15,
    "type": "request",
    "data": undefined,
}

/math-vault/[...mathVaultPaths]
{
    "d": 16,
    "type": "message",
    "data": {
        "type": "request",
        "request": "petState"
    }
}

/math-vault/
{
    "d": 19,
    "type": "message",
    "data": {
        "type": "playcanvasAnalyticsEvent",
        "data": {
            "eventCategory": "mathvault",
            "eventAction": "vaultdoor",
            "eventLabel": "",
            "eventValue": 10,
            "meta": {
                "room": "vault"
            }
        }
    }
}
*/
